import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { reduxForm } from 'redux-form'
import validator from 'validator'
import { I18n } from 'react-redux-i18n'
import {isStrongPassword} from '../../ApplicationUtils'

import classNames from 'classnames'
import styles from './Login.module.scss'
import globalStyles from '../../styles/styles.module.scss'

export const fields = [ 'firstName', 'lastName', 'userName', 'email', 'password', 'confirmPassword' ]

const validate = (values, event) => {
  const errors = {}

  if (event.currentView === 'login') {
    if (!values.userName) {
      errors.userName = I18n.t('Login.required')
    }
    if (!values.password) {
      errors.password = I18n.t('Login.required')
    }
  }

  if (event.currentView === 'register') {
    if (!values.lastName) {
      errors.lastName = I18n.t('Login.required')
    }
    if (!values.firstName) {
      errors.firstName = I18n.t('Login.required')
    }
    if (!values.userName) {
      errors.userName = I18n.t('Login.required')
    }
    if (!values.email) {
      errors.email = I18n.t('Login.required')
    } else if (!validator.isEmail(values.email)) {
      errors.email = I18n.t('Error.validEmail')
    }
    if (!values.password) {
      errors.password = I18n.t('Login.required')
    }
    if (!values.confirmPassword) {
      errors.confirmPassword = I18n.t('Login.required')
    } else if (values.password !== values.confirmPassword) {
      errors.confirmPassword = I18n.t('Error.confirmPassword')
    }
  }

  if (event.currentView === 'create' || event.currentView === 'reinit') {
    if (!values.password) {
      errors.password = I18n.t('Login.required')
    } else if (!isStrongPassword(values.password)) {
      errors.password = I18n.t('Error.passwordSecurity')
    } else if (!values.confirmPassword) {
      errors.confirmPassword = I18n.t('Login.required')
    } else if (values.password !== values.confirmPassword) {
      errors.confirmPassword = I18n.t('Error.confirmPassword')
    }
  }

  if (event.currentView === 'forgot') {
    if (!values.email) {
      errors.email = I18n.t('Login.required')
    } else if (!validator.isEmail(values.email)) {
      errors.email = I18n.t('Error.validEmail')
    }
  }

  return errors
}

class Login extends Component {
  render () {
    let submitButtonClasses = classNames(globalStyles.button, globalStyles.primary)
    let cancelButtonClasses = classNames(globalStyles.button, globalStyles.secondary)
    let buttonLinkClasses = classNames(globalStyles.button,
      globalStyles.link,
      this.props.currentView === 'login' ? null : globalStyles.hidden)

    const { fields: { firstName, lastName, userName, email, password, confirmPassword }, handleSubmit } = this.props

    let loginClassList = classNames(styles.login, this.props.currentView === 'forgot' ? styles.smallBefore : null,
       this.props.currentView === 'create' || this.props.currentView === 'reinit' ? styles.createForm : null)

    return (
      <div className={loginClassList}>
        <div className={styles.logo}></div>
        {this.props.currentView !== 'create' && this.props.currentView !== 'reinit'
          ? <form onSubmit={handleSubmit} autoComplete='off'>
          {this.props.currentView === 'login' || this.props.currentView === 'forgot'
          ? null : <div className={lastName.touched && lastName.error ? styles.error : '' }>
            <div className={this.props.currentView === 'login' || this.props.currentView === 'forgot'
              ? globalStyles.hidden : ''}>
              <label>{I18n.t('Login.lastname')}</label>
              <div className={styles.row}>
                <input type='text' {...lastName}/>
              </div>
              {lastName.touched && lastName.error && <div>{lastName.error}</div>}
            </div>
          </div>}
          {this.props.currentView === 'login' || this.props.currentView === 'forgot'
          ? null : <div className={firstName.touched && firstName.error ? styles.error : '' }>
            <div className={this.props.currentView === 'login' || this.props.currentView === 'forgot'
              ? globalStyles.hidden : ''}>
              <label>{I18n.t('Login.firstname')}</label>
              <div className={styles.row}>
                <input type='text' {...firstName}/>
              </div>
              {firstName.touched && firstName.error && <div>{firstName.error}</div>}
            </div>
          </div>}
          {this.props.currentView === 'forgot'
          ? null : <div className={userName.touched && userName.error ? styles.error : '' }>
            <div className={this.props.currentView === 'forgot' ? globalStyles.hidden : ''}>
              <label>{I18n.t('Login.username')}</label>
              <div className={styles.row}>
                <input type='text' {...userName}/>
              </div>
              {userName.touched && userName.error && <div>{userName.error}</div>}
            </div>
          </div>}
          {this.props.currentView === 'login'
          ? null : <div className={email.touched && email.error ? styles.error : '' }>
            <div className={this.props.currentView === 'login' ? globalStyles.hidden : ''}>
              <label>{I18n.t('Login.email')}</label>
              <div className={styles.row}>
                <input type='email' {...email}/>
              </div>
            </div>
            {email.touched && email.error && <div>{email.error}</div>}
          </div>}
          {this.props.currentView === 'forgot'
          ? null : <div className={password.touched && password.error ? styles.error : '' }>
            <div className={this.props.currentView === 'forgot' ? globalStyles.hidden : ''}>
              <label>{I18n.t('Login.password')}</label>
              <div className={styles.row}>
                <input type='password' {...password}/>
              </div>
              {password.touched && password.error && <div>{password.error}</div>}
            </div>
          </div>}
          {this.props.currentView !== 'register'
          ? null : <div className={confirmPassword.touched && confirmPassword.error ? styles.error : '' }>
            <div className={this.props.currentView !== 'register' ? globalStyles.hidden : ''}>
              <label>{I18n.t('Login.confirmPassword')}</label>
              <div className={styles.row}>
                <input type='password' {...confirmPassword}/>
              </div>
              {confirmPassword.touched && confirmPassword.error && <div>{confirmPassword.error}</div>}
            </div>
          </div>}
          <div>
            <button type='submit' className={submitButtonClasses}
              tabIndex='-1' disabled={lastName.error ||
                firstName.error ||
                userName.error ||
                email.error ||
                password.error ||
                confirmPassword.error}>
              {this.props.currentView === 'login'
              ? I18n.t('Login.connect') : this.props.currentView === 'register'
              ? I18n.t('Login.register') : I18n.t('Login.forgot')}
            </button>
            { this.props.currentView === 'forgot' ? <button type='button' className={cancelButtonClasses}
              onClick={this.props.onClick}>
              {this.props.currentView === 'login'
              ? I18n.t('Login.register') : I18n.t('Application.cancel')}
            </button> : null}
            <button type='button' className={buttonLinkClasses}
              onClick={this.props.onForgotClick}>
              {I18n.t('Login.forgot')}
            </button>
          </div>
        </form> : <form onSubmit={handleSubmit} autoComplete='off'>
          <div>
            <div>
              <label>{I18n.t('Login.email')}</label>
              <div className={styles.row}>
                <input type='email' disabled value={this.props.emailCreation}/>
              </div>
            </div>
          </div>
          <div className={password.touched && password.error ? styles.error : '' }>
            <div>
              <label>{I18n.t('Login.password')}</label>
              <div className={styles.row}>
                <input type='password' {...password}/>
              </div>
              {password.touched && password.error && <div>{password.error}</div>}
            </div>
          </div>
          <div className={confirmPassword.touched && confirmPassword.error ? styles.error : '' }>
            <div>
              <label>{I18n.t('Login.confirmPassword')}</label>
              <div className={styles.row}>
                <input type='password' {...confirmPassword}/>
              </div>
              {confirmPassword.touched && confirmPassword.error && <div>{confirmPassword.error}</div>}
            </div>
          </div>
          <div>
            <button type='submit' className={submitButtonClasses}
              tabIndex='-1' disabled={password.error ||
                confirmPassword.error}>
              {this.props.currentView === 'create' ? I18n.t('Login.register') : I18n.t('Login.connect')}
            </button>
          </div>
        </form>}
      </div>
    )
  }
}

Login.propTypes = {
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onForgotClick: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
  resetForm: PropTypes.func.isRequired,
  emailCreation: PropTypes.string,
}

export default reduxForm({
  form: 'sign-up-form',
  fields,
  validate,
})(Login)
